import { render, staticRenderFns } from "./ArticlesBlock.vue?vue&type=template&id=62585a4d&scoped=true&"
import script from "./ArticlesBlock.vue?vue&type=script&lang=js&"
export * from "./ArticlesBlock.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesBlock.vue?vue&type=style&index=0&id=62585a4d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62585a4d",
  null
  
)

export default component.exports